import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from '../../services/data.service';

@Component({
    selector: 'app-property-dialog',
    template: `
    <h2 mat-dialog-title>Eigenschaft definieren</h2>
    <form [formGroup]="propertyForm" (ngSubmit)="onSubmit()">
      <div class="property-form">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
        <mat-form-field>
          <mat-label>�bersetzung</mat-label>
          <input matInput formControlName="translation">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Typ</mat-label>
          <mat-select formControlName="type" (selectionChange)="onTypeChange()">
            <mat-option *ngFor="let type of allTypes" [value]="type.Value">{{type.Caption}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-checkbox formControlName="readOnly">Nur lesen</mat-checkbox>
        <mat-checkbox formControlName="mandatoryField">Pflichtfeld</mat-checkbox>
        <mat-checkbox formControlName="nullable">Nullable</mat-checkbox>
        <mat-checkbox formControlName="list">Liste</mat-checkbox>
        <ng-container *ngIf="showAdvancedTypeField">
          <mat-form-field>
            <mat-label>{{advancedTypeLabel}}</mat-label>
            <mat-select formControlName="advancedType">
              <mat-option *ngFor="let item of advancedTypeOptions" [value]="item.Value">{{item.Caption}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-checkbox formControlName="isShared" (change)="isSharedChanged($event)">Als Referenz</mat-checkbox>
          <mat-checkbox formControlName="isReverse" [disabled]="!propertyForm.get('isShared').value">Reverse</mat-checkbox>
        </ng-container>
        <mat-form-field *ngIf="showDefaultField">
          <mat-label>Default</mat-label>
          <input matInput formControlName="default">
        </mat-form-field>
      </div>
      <div mat-dialog-actions>
        <button mat-button (click)="onCancel()">Abbrechen</button>
        <button mat-button color="primary" type="submit" [disabled]="!propertyForm.valid">Hinzuf�gen</button>
      </div>
    </form>
  `,
    styles: [`
    .property-form {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    mat-form-field {
      width: 100%;
    }
  `]
})
export class PropertyDialogComponent implements OnInit {
    propertyForm: FormGroup;
    allTypes = [];
    allTables = [];
    allStaticTables = [];
    allEnums = [];

    constructor(
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<PropertyDialogComponent>,
        private dataService: DataService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.propertyForm = this.fb.group({
            name: ['', Validators.required],
            translation: [''],
            type: ['', Validators.required],
            readOnly: [false],
            mandatoryField: [false],
            nullable: [false],
            list: [false],
            advancedType: [''],
            isShared: [false],
            isReverse: [false],
            default: ['']
        });

        this.allTables = data.AllTables;
        this.allStaticTables = data.AllStaticTables;
        this.allEnums = data.AllEnums;
    }

    ngOnInit() {
        this.loadTypes();
        this.propertyForm.get('type').valueChanges.subscribe(() => {
            this.updateFormBasedOnType();
        });
    }

    loadTypes() {
        this.dataService.GetList('dynamic', 'GetDynamicTypes').subscribe((data) => {
            if (data) {
                this.allTypes = data;
            }
            this.allTypes.push({ Caption: 'Static', Value: '9DFCE24E-FCB8-4CD8-B724-EFB87810EE80' });
        });
    }

    onTypeChange() {
        this.propertyForm.patchValue({ default: null, advancedType: null });
        this.updateFormBasedOnType();
    }

    updateFormBasedOnType() {
        const typeValue = this.propertyForm.get('type').value;
        this.propertyForm.get('advancedType').setValidators(this.showAdvancedTypeField ? [Validators.required] : null);
        this.propertyForm.get('advancedType').updateValueAndValidity();
    }

    get showAdvancedTypeField(): boolean {
        const typeValue = this.propertyForm.get('type').value;
        return typeValue === 'c4ef25dd-c176-418c-836e-f26c52d7f59c' ||
            typeValue === '9DFCE24E-FCB8-4CD8-B724-EFB87810EE80' ||
            typeValue === '876cf188-243b-49ed-91ab-b2cf27216a30';
    }

    get showDefaultField(): boolean {
        const typeValue = this.propertyForm.get('type').value;
        return typeValue !== '876cf188-243b-49ed-91ab-b2cf27216a30' &&
            typeValue !== 'c4ef25dd-c176-418c-836e-f26c52d7f59c' &&
            typeValue !== '9DFCE24E-FCB8-4CD8-B724-EFB87810EE80';
    }

    get advancedTypeLabel(): string {
        const typeValue = this.propertyForm.get('type').value;
        if (typeValue === '876cf188-243b-49ed-91ab-b2cf27216a30') {
            return 'Enum';
        }
        return 'Tabelle';
    }

    get advancedTypeOptions(): any[] {
        const typeValue = this.propertyForm.get('type').value;
        if (typeValue === '876cf188-243b-49ed-91ab-b2cf27216a30') {
            return this.allEnums;
        } else if (typeValue === '9DFCE24E-FCB8-4CD8-B724-EFB87810EE80') {
            return this.allStaticTables;
        }
        return this.allTables;
    }

    onSubmit() {
        if (this.propertyForm.valid) {
            this.dialogRef.close(this.propertyForm.value);
        }
    }

    onCancel() {
        this.dialogRef.close();
    }

    isSharedChanged(event: any) {
        if (event && event.checked === false) {
            this.propertyForm.patchValue({ isReverse: false });
        }
    }
}